import { List } from "immutable";
import * as actions from "../actions/NavigationActions";
import * as routerActions from "../actions/RouterActions";
import { TreeBranch } from "../models/navigation";
import { LocalStorage } from "../services/Localstorage";
import { initialState, NavigationState } from "../store/NavigationState";
import buildReducer from "../utils/ReducerBuilder";

const activateNavItems = (currentPath: string, branches: List<TreeBranch | undefined>): List<TreeBranch | undefined> => {
    if (Array.isArray(branches))
        branches = List(branches);

    // the home branch is the one without any parents
    const homeIdx = branches.findIndex((b) => b !== undefined && !b.parentIds.length);

    if (homeIdx === -1) {
        if (!branches.size)
            console.warn("No home page found", branches);
        return branches;
    }

    let modList = List<TreeBranch | undefined>();

    // deactivate all
    modList = branches.map((b, i) => {
        if (b)
            b.active = false;
        return b;
    })
    .filter((b) => b !== undefined)
    .toList();

    if (currentPath === "/") {
        return modList.update(homeIdx, (b) => {
            if (b)
                b.active = true;
            return b;
        });
    }

    const activeChild = modList.find((b) => b !== undefined && b.url === currentPath);

    // no URL match found
    if (!activeChild)
        return modList;

    // activate child and all parents
    const IdsToActivate = [activeChild.id].concat(activeChild.parentIds);
    modList = modList.map((b, i) => {
        if (b && IdsToActivate.indexOf(b.id) > -1) {
            b.active = true;
        }
        return b;
    }).toList();

    return modList;
};

export const NavigationReducer = buildReducer<NavigationState>(initialState)
    .handle(routerActions.onPathChanged, (state, action) => {
        if (action.payload === undefined)
            return state;

        const branches = activateNavItems(action.payload.pathname, state.branches);

        // add new path to pathHistory
        let pathHistory = state.pathHistory;
        const newPath = action.payload.pathname + action.payload.search + action.payload.hash;
        if (!pathHistory.size || (pathHistory.last() !== newPath)) {
            pathHistory = pathHistory.push(newPath);

            // only keep track of 20 most recent paths
            if (pathHistory.size > 20)
                pathHistory = pathHistory.takeLast(20).toList();
        }

        return {
            ...state,
            branches,
            currentPath: action.payload.pathname,
            pathHistory,
        };
    })
    .handle(actions.navigationReceived, (state, action) => {
        if (action.payload === undefined)
            throw new Error (`Payload cannot be undefined for ${actions.navigationReceived.toString()}`);

        // save the main nav in local storage for quick retrieval on page [re]load.
        LocalStorage.setItem("state.nav.tree", action.payload, true);

        // get the current browse path
        const currentPath = state.currentPath;
        const branches = activateNavItems(currentPath, List(action.payload));

        return {
            ...state,
            branches,
            loading: false,
        };
    })
    .handle(actions.navigationReceivedFromStorage, (state, action) => {
        return {
            ...state,
            hasStorageNav: true,
        };
    })
    .handle(actions.navigationRequested, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .handle(actions.toggleInitialized, (state, action) => {
        return {
            ...state,
            initialized: action.payload || false,
        };
    })
    .handle(actions.toggleLoading, (state, action) => {
        return {
            ...state,
            loading: action.payload || false,
        };
    })
    .handle(actions.updateChildOfPath, (state, action) => {
        return {
            ...state,
            childOfPath: action.payload,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/NavigationReducer.ts